<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/merchantecpie/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="交易量">
        <el-input v-model="formModel.money" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <div class="chart-container" ref="chart"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import CommonTopForm from "components/common/CommonTopForm";
import StatisticsService from "service/StatisticsService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "merchantecpie",
  components: {
    CommonTopForm,
  },
  data() {
    return {
      formModel: {
        userId: "",
        time: "",
      },
      tableData: [],
      submitService: StatisticsService.merchantecpieList,
      chartData: [], // 添加chartData数组
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    this.renderChart();
    this.attachEvents();
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        money: this.formModel.money,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
      };
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;

        // 遍历后端返回的数据，将其转换为饼图所需的格式
        this.chartData = result.map((item) => {
          return {
            value: item.value, // 使用后端返回的值作为饼图的数据值
            name: item.name, // 使用后端返回的值作为饼图的数据名称
          };
        });
        console.log(this.chartData);
        this.renderChart();
      });
    },
    renderChart() {
      const option = {
        title: {
          text: "男女人数比例和具体值",
          textStyle: {
            fontWeight: "normal",
            fontSize: 16,
          },
          left: "center",
        },
        color: ["#6395F9", "#62DAAB", "#657798", "#F6C022", "#E96C5B"],
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: {c}",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "14",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10,
            },
            data: this.chartData, // 将chartData作为饼图的数据来源
          },
        ],
        animationDuration: 1000, // 动画时长
        animationEasing: "cubicInOut", // 动画缓动效果
      };

      this.chart.setOption(option);
    },
    attachEvents() {
      this.chart.on("click", this.handleChartClick);
    },
    handleChartClick(params) {
      console.log(params);
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 500px;
  height: 500px;
  padding-top: 20px;
  margin: auto;
  /* background: yellow; */
}
</style>


// WEBPACK FOOTER //
// src/view/page/Statistics/MerchantEcPie.vue